import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService";

import DataTableBloc from "../Blocs/DataTableBloc";
import apiResponse from "../../../../../services/apiResponse";

import moment from "moment";

class TableActiveComponent extends Component {
  userdata = JSON.parse(localStorage.getItem("userdata"));
  is_eselon =
    typeof this.userdata.echelon_code === "string" &&
    (this.userdata.echelon_code.startsWith("1") ||
      this.userdata.echelon_code.startsWith("2"))
      ? 1
      : 0;

  dataTableBloc = new DataTableBloc();

  source;
  historyMonth = "skp_history_month_tunsus"; //
  historyYear = "skp_history_year_tunsus"; //
  historyTable = "historySkpTunjanganKhususTableActive"; // Nama di tiap tabel harus beda karena akan disimpan di session
  defaultOrder = "special_allowance_summary_id"; // orderBy
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      createUuid: null,
      updateUuid: null,
      previewUuid: null,
      inactiveUuid: null,
      activeUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      runType: null,
      confirmInfo: "Apakah anda yakin akan melakukan verifikasi tunkin?",
      roleId: localStorage.getItem("currentRoleId"),
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
      detailUuid: null,
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });
  dateParse = (input) => {
    let res = "";
    if (input !== "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };
  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    localStorage.setItem(
      this.historyMonth,
      JSON.stringify(this.props.additionalFilter.month)
    );

    localStorage.setItem(
      this.historyYear,
      JSON.stringify(this.props.additionalFilter.year)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      roleId: this.state.roleId,
      is_echelon: this.is_eselon,
      ...this.props.additionalFilter,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };
  activeData = async () => {
    await this.dataTableBloc.fetchActive({ uuid: this.state.activeUuid });
  };

  handleButtonExport = () => {
    // alert('ooooooooooooooo')
    this.dataTableBloc.fetchExport({
      month: this.props.additionalFilter.month,
      year: this.props.additionalFilter.year,
    });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          this.props.setDocument(response?.document);
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    // this.dataTableBloc.inactiveChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       this.setState(
    //         {
    //           loading: false,
    //           success: true,
    //           loadingTable: true,
    //           inactiveUuid: null,
    //         },
    //         function () {
    //           this.setTokenAPI();
    //         }
    //       );
    //       break;
    //     case apiResponse.ERROR:
    //       this.setState({
    //         loading: false,
    //         failed: true,
    //       });
    //       break;
    //     default:
    //       break;
    //   }
    // });
    // this.dataTableBloc.activeChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.COMPLETED:
    //       this.setState(
    //         {
    //           loading: false,
    //           success: true,
    //           loadingTable: true,
    //           activeUuid: null,
    //         },
    //         function () {
    //           this.setTokenAPI();
    //         }
    //       );
    //       break;
    //     case apiResponse.ERROR:
    //       this.setState({
    //         loading: false,
    //         failed: true,
    //       });
    //       break;
    //     default:
    //       break;
    //   }
    // });

    this.dataTableBloc.exportChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          this.setState({
            loading: true,
          });
          break;
        case apiResponse.COMPLETED:
          const link = result.data.response;
          window.open(link.file_url, "_blank");
          //window.location.href = link.file_url
          this.setState({
            loading: false,
            success: true,
          });
          setTimeout(() => {
            this.setState({
              success: false,
            });
          }, 1000);
          break;
        case apiResponse.ERROR:
          this.setState({
            urlFileDetail: link,
            loading: false,
            failed: true,
          });
          setTimeout(function () {
            this.setState({
              failed: false,
            });
          }, 1000);
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
    // this.dataTableBloc.inactiveChannel?.unsubscribe();
    // this.dataTableBloc.activeChannel?.unsubscribe();
    this.dataTableBloc.exportChannel?.unsubscribe();
  }

  columns = [
    {
      key: "special_allowance_summary_employee_name",
      text: "Pegawai",
      sortable: true,
      cell: (record) => {
        var plt = record.special_allowance_summary_plt_position_uuid;
        return (
          <span>
            <strong>{record.special_allowance_summary_employee_nip}</strong>
            <br></br>
            {record.special_allowance_summary_employee_name}
            <br></br>
            {/* {plt != null && plt != "" ? "Plt. " : ""} */}
            {/* {record.special_allowance_summary_employee_current_position_name} */}
            {/* <br></br> */}
            {record.special_allowance_summary_employee_current_position_name ? (
              <>
                {
                  record.special_allowance_summary_employee_current_position_name
                }
              </>
            ) : (
              <>
                <span style={{ color: "red" }}>
                  {record.special_allowance_summary_skp_position_name}
                </span>
              </>
            )}
            <br></br>
          </span>
        );
      },
    },
    {
      key: "special_allowance_summary_work_result",
      text: "Hasil Kerja",
      sortable: true,
      cell: "-",
    },
    {
      key: "special_allowance_summary_work_behavior",
      text: "Perilaku Kerja",
      sortable: true,
      cell: "-",
    },

    {
      key: "special_allowance_summary_final_result",
      text: "Hasil Akhir",
      sortable: true,
      cell: "-",
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.special_allowance_summary_id;
        let status = record.special_allowance_summary_status;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.special_allowance_summary_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detil
              </Tooltip>
            </span>
          </Fragment>
        );
      },
    },
  ];
  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={`Apakah anda yakin akan mengubah status data ini?`}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil diubah"
          failedTitle="Gagal!"
          failedInfo="Data gagal diubah"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.createUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/verifikasi_tunjangan_khusus.html?create_assestment&uuid=" +
              this.state.createUuid
            }
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/verifikasi_tunjangan_khusus.html?update_assestment&uuid=" +
              this.state.updateUuid
            }
          />
        ) : null}

        {this.state.previewUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/verifikasi_tunjangan_khusus.html?preview_assestment&uuid=" +
              this.state.previewUuid
            }
          />
        ) : null}
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/skp_tunjangan_khusus.html?detail&uuid=" +
              this.state.detailUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TableActiveComponent;
